<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import SizeInner from "./SizeInner.svelte";
  import { linkTo } from "$lib/utils/url";

  export let margin = "";
  export let sizeOption: {
    value: string;
    inStock?: boolean;
    displayName?: string;
  };
  export let selected = false;
  export let small = false;
  export let href = "";

  export let preventDefault: boolean = false;

  const dispatch = createEventDispatcher();
  const onSelect = e => {
    preventDefault && e.preventDefault();
    selected = true;
    dispatch("select", sizeOption);
  };

  let inStock: boolean;
  $: inStock = sizeOption.inStock;

  const style = margin ? `margin: ${margin}` : "";
  let theme = "on-surface";
  $: if (!inStock && !selected) {
    theme = "on-surface-30";
  } else if (inStock && selected) {
    theme = "inverse-on-surface";
  } else {
    theme = "on-surface";
  }
</script>

<style lang="scss">
  .size {
    align-items: center;
    border: 1px solid $on-surface-10;
    background-color: $surface;
    border-radius: 12px;
    cursor: pointer;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    min-height: 25px;
    min-width: 42px;
    padding: 4px 8px;
    text-decoration: none;
    position: relative;
    z-index: 5;

    &--small {
      min-height: 16px;
      min-width: 42px;
      padding: 4px;
    }

    &--selected {
      background: $inverse-surface;
    }

    &--out-of-stock {
      &:before {
        position: absolute;
        content: "";
        left: 0;
        top: 50%;
        right: 0;
        border-top: 1px solid $on-surface-10;
        transform: rotate(-25deg) translateY(-1.2px);
      }
      &__selected {
        border-color: $on-surface;

        &:before {
          border-color: $inverse-surface;
        }
      }
    }
  }
</style>

{#if sizeOption}
  {#if href}
    <a
      href={linkTo(href)}
      class={`size ${selected && inStock ? "size--selected" : ""} ${
        small ? "size--small" : ""
      } ${!inStock ? "size--out-of-stock" : ""} ${
        selected && !inStock ? "size--out-of-stock__selected" : ""
      }`}
      {style}
    >
      <SizeInner {sizeOption} {theme} />
    </a>
  {:else}
    <button
      class={`size ${selected && inStock ? "size--selected" : ""} ${
        small ? "size--small" : ""
      } ${!inStock ? "size--out-of-stock" : ""} ${
        selected && !inStock ? "size--out-of-stock__selected" : ""
      }`}
      {style}
      on:click|preventDefault={onSelect}
    >
      <SizeInner {sizeOption} {theme} />
    </button>
  {/if}{/if}
